/* CLD Wet line buy box (section cld-wet-hero): size, subscription, hair type, gallery and add to cart.
   Add to cart uses the theme's own cart (EOLUX.Cart) so the drawer refreshes and opens, like cld-home.js.
   No gift is added here: the free brush is only for tools of 100 € or more. */
(function () {
  if (window.__cldWet) return;
  window.__cldWet = true;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function num(v, dec, th, ds) {
    var p = v.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return p.join(ds);
  }
  function money(cents) {
    var fmt = (window.EOLUX && window.EOLUX.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = cents / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return num(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return num(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(v, 0, '.', ',');
      return num(v, 2, ',', '.');
    }).replace(/[.,]00(?!\d)/, '');
  }

  function init(root) {
    if (!root || root._cw) return;
    root._cw = true;
    var data = { variants: [] };
    try { data = JSON.parse(root.querySelector('[data-cw-json]').textContent); } catch (e) {}
    var idInput = root.querySelector('[data-cw-id]');
    var spInput = root.querySelector('[data-cw-sp]');
    var btn = root.querySelector('[data-cw-add]');
    var free = +root.getAttribute('data-free') || 0;

    function variant() {
      var id = +idInput.value;
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return data.variants[0];
    }
    /* The gallery is the theme's own (snippet product-media-gallery, run by theme.js), as on the CLD
       product page: showing a variant's photo = clicking its thumbnail, exactly what the theme does. */
    function showMedia(id) {
      if (!id) return;
      var th = root.querySelector('[data-media-thumb="' + id + '"]');
      if (th && !th.classList.contains('product-gallery__thumb--active')) th.click();
    }

    /* Gallery videos (wet line only): no controls, always muted, loop, start by themselves.
       The theme snippet renders them with controls and sound for the normal product pages, so they are
       switched here. The one on screen plays; the others pause until their thumbnail is chosen. */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vids = root.querySelectorAll('.product-gallery video');
    function syncVideos() {
      each(vids, function (v) {
        var item = v.closest('[data-media-id]');
        var shown = !item || !item.hidden;
        if (shown && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }
    each(vids, function (v) {
      v.removeAttribute('controls');
      v.controls = false;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.loop = true;
      v.preload = 'auto';
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('tabindex', '-1');
      var item = v.closest('[data-media-id]');
      if (item && window.MutationObserver) new MutationObserver(syncVideos).observe(item, { attributes: true, attributeFilter: ['hidden'] });
    });
    if (vids.length) {
      syncVideos();
      document.addEventListener('visibilitychange', function () { if (!document.hidden) syncVideos(); });
    }

    function update() {
      var v = variant();
      if (!v) return;
      each(root.querySelectorAll('[data-cw-variant]'), function (c) { c.setAttribute('aria-pressed', +c.getAttribute('data-cw-variant') === v.id ? 'true' : 'false'); });
      var group = null;
      each(root.querySelectorAll('[data-cw-plans]'), function (g) {
        var on = +g.getAttribute('data-cw-plans') === v.id;
        g.hidden = !on;
        if (on) group = g;
      });
      var checked = group && group.querySelector('input:checked');
      var plan = checked ? checked.value : '';
      var price = checked ? +checked.getAttribute('data-price') : v.price;
      spInput.value = plan;
      var now = root.querySelector('[data-cw-now]'), was = root.querySelector('[data-cw-was]'), note = root.querySelector('[data-cw-note]');
      if (now) now.textContent = money(price);
      var old = plan ? v.price : (v.compare > v.price ? v.compare : 0);
      if (was) { was.hidden = !(old > price); was.textContent = old ? money(old) : ''; }
      if (note) note.textContent = v.note || '';
      var sn = root.querySelector('[data-cw-size-name]'), sv = root.querySelector('[data-cw-size-vol]');
      if (sn && v.label) sn.textContent = v.label;
      if (sv && v.vol) sv.textContent = v.vol;
      var ship = root.querySelector('[data-cw-ship]');
      if (ship) ship.textContent = free && price >= free ? root.getAttribute('data-ship-free') : root.getAttribute('data-ship-paid');
      btn.disabled = !v.available;
      btn.textContent = v.available ? root.getAttribute('data-btn') + ' · ' + money(price) : root.getAttribute('data-soldout');
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-cw-variant]');
      if (card && !card.disabled) {
        idInput.value = card.getAttribute('data-cw-variant');
        var v = variant();
        if (v && v.media) showMedia(v.media);
        update();
        if (window.history && history.replaceState) {
          var u = new URL(location.href);
          u.searchParams.set('variant', idInput.value);
          history.replaceState(history.state, '', u.toString());
        }
        return;
      }
      var hb = e.target.closest('[data-cw-hair]');
      if (hb) {
        var k = hb.getAttribute('data-cw-hair');
        each(root.querySelectorAll('[data-cw-hair]'), function (b) { b.setAttribute('aria-pressed', b === hb ? 'true' : 'false'); });
        each(root.querySelectorAll('[data-cw-tip]'), function (t) { t.hidden = t.getAttribute('data-cw-tip') !== k; });
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target && e.target.closest('[data-cw-plans]')) update();
    });

    root.querySelector('[data-cw-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      var E = window.EOLUX || {};
      var routes = E.routes || {};
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var addUrl = (routes.cart_add || rootUrl + 'cart/add') + '.js';
      var item = { id: +idInput.value, quantity: 1 };
      if (spInput.value) item.selling_plan = +spInput.value;
      var body = { items: [item], sections: ['cart-drawer'] };
      btn.setAttribute('aria-busy', 'true');
      var req = (E.Cart && E.Cart.request) ? E.Cart.request(addUrl, body) : fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error((E.strings && E.strings.cartError) || 'Error'); return r.json(); });
      req.then(function (res) {
        if (E.Cart && E.Cart.render) E.Cart.render(res && res.sections);
        var drawer = document.querySelector('[data-cart-drawer]');
        if (E.cartType === 'drawer' && drawer && E.Drawer) E.Drawer.open(drawer);
        else window.location.href = routes.cart || rootUrl + 'cart';
      }).catch(function (err) {
        var label = btn.textContent;
        btn.textContent = (err && err.message) || 'Error';
        setTimeout(function () { btn.textContent = label; update(); }, 2600);
      }).then(function () { btn.removeAttribute('aria-busy'); });
    });

    update();
  }

  function start() { each(document.querySelectorAll('[data-cw-buy]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
